/* ── TALO Theme JS ── */

function swapImg(el, src) {
  document.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
  el.classList.add('active');
  const main = document.getElementById('main-product-img');
  if (main) {
    main.style.opacity = '0';
    setTimeout(() => { main.src = src; main.style.opacity = '1'; main.style.transition = 'opacity .25s'; }, 150);
  }
}

function updateCartCount() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const el = document.querySelector('.cart-count');
      if (el) el.textContent = cart.item_count > 0 ? cart.item_count : '';
    });
}

document.addEventListener('DOMContentLoaded', updateCartCount);

// ── Waitlist Popup ──
window.closePopup = function(){
  var p = document.getElementById('waitlist-popup');
  if(p) p.classList.remove('active');
};

document.addEventListener('DOMContentLoaded', function(){
  // Show on every page load after 1.5s
  setTimeout(function(){
    var p = document.getElementById('waitlist-popup');
    if(p) p.classList.add('active');
  }, 1500);

  // Close on overlay background click
  var overlay = document.getElementById('waitlist-popup');
  if(overlay){
    overlay.addEventListener('click', function(e){
      if(e.target === overlay) closePopup();
    });
  }

  // Close on Esc key
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') closePopup();
  });
});
